// Putting it in a separate file because of circular dependency issues
export const getSessionId = () => {
  if (typeof window !== 'undefined' && typeof window.heap?.getSessionId === 'function') {
    return window.heap?.getSessionId();
  }
  return '';
};
